import styled from "styled-components";

export const StyledSectionWrapper = styled.div`
  padding: 0 6% 14px 8%;
  
  & > h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 18px;
    color: #233247;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 72px 135px 80px 65px;
    max-width: 1280px;
    margin: 0 auto;
    & > h2 {
      margin-bottom: 90px;
    }
  }
`;
export const StyledDescription = styled.div`
  display: none;
  
  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    margin-left: auto;
    max-width: 311px;
    display: block;
    padding-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    border-left: 3px solid #f9d937;
    height: fit-content;
    width: 50%;
    color: #586981;
  }
`;
export const StyledBenefitsList = styled.div`
  & > .benefit span {
    min-width: 60px;
    padding-top: 8px;
  }
  
  & p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;

    color: #586981;
  }
  
  & h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 5px;
    color: #233247;
  }
  
  & > .benefit {
    display: flex;
    margin-bottom: 22px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    max-width: 300px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    display: flex;
    flex-wrap: wrap;
    max-width: 600px;
    padding-left: 30px;
    & > .benefit {
      width: 50%;
      margin-bottom: 50px;
      padding-right: 40px;
    }
  }
`;
